export function browserCompatible() {
  return !(
    typeof navigator.locks === 'undefined' || typeof navigator.locks.request === 'undefined'
  );
}
